<template>
  <div>
    <Head title="Mitarbeiter/Innen" />
    <div class="flex justify-between flex-wrap ">
      <h1 class="mb-8 text-3xl font-bold flex items-center text-orfBlue-100">
        <HeroIcon name="users" class="mr-2 h-10 w-10 fill-orfBlue-100" />
        <div class="mt-1">Mitarbeiter/Innen ({{users.length}})</div>
      </h1>
    </div>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" :show-filter="true" :show-reset="true" class="w-full" @reset="reset">
        <div class="flex items-center flex-wrap">
          <div class="flex items-center">
            <label class="text-gray-700 mr-3">Abteilung:</label>
            <select v-model="form.department" class="form-select w-40">
              <option selected :value="null" disabled>Auswählen</option>
              <option v-for="department in departments" :key="department.id" :value="department.id">{{department.name}}</option>
            </select>
          </div>
          <div class="flex items-center sm:ml-4">
            <label class="text-gray-700 mr-3">Team:</label>
            <select v-model="form.team" class="form-select w-40">
              <option selected :value="null" disabled>Auswählen</option>
              <option v-for="team in teams" :key="team.id" :value="team.id">{{team.name}}</option>
            </select>
          </div>
        </div>
      </search-filter>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <div class="w-full whitespace-nowrap">
        <div class="hidden lg:flex items-center text-left font-bold">
          <div class="pb-4 pt-6 px-6 w-1/6">Name</div>
          <div class="pb-4 pt-6 px-6 w-1/6">Abteilung</div>
          <div class="pb-4 pt-6 px-6 w-1/6">Team</div>
          <div class="pb-4 pt-6 px-6 w-40">Heute im</div>
          <div class="pb-4 pt-6 px-6 flex-grow">Email</div>
          <div class="pb-4 pt-6 px-6 w-1/6 text-right">Options</div>
        </div>
        <div v-for="user in users" :key="user.id" class="text-xxs lg:text-sm flex-wrap flex items-center border-t hover:bg-gray-100 focus-within:bg-gray-100">
          <div class="w-40 lg:w-1/6">
            <Link class="flex items-center px-6 py-4 font-bold lg:font-normal focus:text-orfBlue-500" :href="`/?user=${user.id}`">
              <img v-if="user.photo" class="block -my-2 mr-2 w-5 h-5 rounded-full" :src="user.photo" />
              {{ user.name }}
              <HeroIcon v-if="user.deleted_at" name="trash" icon-mini class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
            </Link>
          </div>
          <div class="w-40 lg:w-1/6">
            <Link class="flex items-center px-6 py-4" :href="`/?user=${user.id}`" tabindex="-1">
              {{ user.department ? user.department.name : '' }}
            </Link>
          </div>
          <div class="w-40 lg:w-1/6">
            <Link class="flex items-center px-6 py-4" :href="`/?user=${user.id}`" tabindex="-1">
              {{ user.team ? user.team.name : '' }}
            </Link>
          </div>
          <div class="hidden lg:flex w-40">
            <Link class="flex items-center px-6 py-4 capitalize" :href="`/?user=${user.id}`" tabindex="-1">
              <div v-if="user.event_today" class="flex items-center" :class="'text-' + user.event_today.type + '-100'">
                <HeroIcon :name="user.event_today.type" class="h-4 w-4 mr-1" :class="'fill-' + user.event_today.type + '-100'"/>
                {{ user.event_today.type}}
              </div>
              <div v-else class="">
                -
              </div>
            </Link>
          </div>
          <div class="lg:flex flex-grow">
            <div class="px-6 py-4">
              {{ user.email }}
            </div>
          </div>
          <div class="lg:w-1/6 px-6 py-4 flex h-full items-center justify-end">
            <loading-button v-if="is_admin || ($page.props.auth.user.id == user.department.user_id)" text="Bearbeiten" icon-name="pencil-square" icon-mini func="link" small inverted :href="`/users/${user.id}/edit`"/>
            <loading-button text="Kalender" icon-name="search" icon-custom-icon func="link" small :href="`/users/${user.id}`"/>
          </div>
        </div>
        <div v-if="users.length === 0">
          <div class="px-6 py-4 border-t" colspan="4">No users found.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import HeroIcon from '@/Shared/HeroIcon.vue'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import LoadingButton from '@/Shared/LoadingButton.vue'

export default {
  components: {
    LoadingButton,
    Head,
    HeroIcon,
    Link,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    users: Array,
    is_admin: Boolean,
    teams: Array,
    departments: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        department: this.filters.department,
        team: this.filters.team,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        if (this.form.search == ''){
          this.reset()
        } else {
          this.$inertia.reload({data: pickBy(this.form), preserveState: true})
        }
      }, 150),
    },
  },
  methods: {
    reset() {
      this.$inertia.get('users', {}, {
        onSuccess: () => {
          document.getElementById('searchInput').focus()
        },
      })
    },
  },
}
</script>
